import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dataCompare, dataCompare_currency, compare_currency_other } from "@/api/dataAll/dataCompare";
import pageMinx from "./mixins/pageMinx";
export default {
  mixins: [tabulation, pageMinx],
  data: function data() {
    return {
      // finallyFn: ['getdataCompare'],
      originaltableList: [],
      originaltableListP: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }],
      originaltableListVND: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费金额(元,越南盾)',
        key: 'new_device_recharge_amountexchange'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '充值总额(元,越南盾)',
        key: 'recharge_amountexchange'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }, {
        name: '新增账号付费金额(元,越南盾)',
        key: 'register_recharge_amountexchange'
      }],
      originaltableListUSD: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费金额(元,美元)',
        key: 'new_device_recharge_amountexchange'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '充值总额(元,美元)',
        key: 'recharge_amountexchange'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }, {
        name: '新增账号付费金额(元,美元)',
        key: 'register_recharge_amountexchange'
      }],
      rawDatas: {},
      tableData: [],
      screen: [],
      tableList: [],
      reqFn: 'getdataCompare',
      name: 'oneHour'
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    resettingData: function resettingData() {
      this.tableData = [];
      this.tableList = [];
      this.IntegralrawData = {};
    },
    // 小时数据
    getdataCompare: function getdataCompare() {
      var _this = this;

      var isverification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.rawData.game_mark) {
        return;
      } // if(this.currencyClose && !this.searchData.currency_info){
      //   if(isverification){
      //     this.$message.error('请选择货币类型')
      //   }   
      //   return
      // }


      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(replace) {
          var res, dbres, currentHour, todayTime, reqFn, handleQueryData, cacheHourData, cacheHourObj, mathNum, hourDate, queryData, defaultData, _queryData;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.reqLoading = true; // 初始化响应对象

                  res = {
                    data: {}
                  }; // 从数据库获取数据

                  _context.next = 4;
                  return _this.$DBControls.get(_this.name + _this.dataConvert());

                case 4:
                  dbres = _context.sent;

                  if (!(dbres && dbres.code == 500)) {
                    _context.next = 8;
                    break;
                  }

                  _this.getdataCompare(true);

                  return _context.abrupt("return");

                case 8:
                  // 获取当前小时
                  currentHour = _this.$times.theDay('HH');
                  todayTime = _this.$times.timestampToTime(new Date(_this.$times.zeroTimeZone()).getTime() / 1000, 'YY-MM-DD');
                  reqFn = dataCompare;

                  if (_this.currencyClose && !_this.searchData.pay_channel) {
                    reqFn = dataCompare_currency;
                  } else if (_this.searchData.pay_channel) {
                    reqFn = compare_currency_other;
                  }

                  _context.next = 14;
                  return _this.getexchangeRate();

                case 14:
                  if (_this.queryCurrency == 'VND') {
                    _this.originaltableList = _this.originaltableListUSD;
                  } else if (_this.queryCurrency == 'USD') {
                    _this.originaltableList = _this.originaltableListP;
                  } else {
                    _this.originaltableList = _this.originaltableListP;
                  }

                  _this.screen = _this.originaltableList.map(function (item) {
                    return item.key;
                  }); // 数据处理函数

                  handleQueryData = function handleQueryData(queryData) {
                    if (queryData.status === 200) {
                      var dataToUpdate = queryData.data;
                      var dataNew = JSON.parse(JSON.stringify(dataToUpdate));
                      var currentHourList = {};

                      for (var k in dataNew[todayTime]) {
                        if (parseInt(k) < currentHour) {
                          currentHourList[k] = dataNew[todayTime][k];
                        }
                      }

                      var endData = _objectSpread({}, dataNew[todayTime]);

                      var storeData = {
                        todayHoure: currentHourList,
                        houreDate: todayTime
                      };

                      _this.$DBControls.update(_this.name + _this.dataConvert(), storeData);

                      res.data = dataToUpdate;
                    }
                  };

                  if (!dbres) {
                    _context.next = 31;
                    break;
                  }

                  cacheHourData = dbres.content.houreDate == todayTime ? dbres.content.todayHoure : {};
                  cacheHourObj = Object.keys(cacheHourData).map(function (i) {
                    return parseInt(i);
                  });
                  mathNum = Math.max.apply(null, cacheHourObj) + 1;
                  hourDate = {
                    start_hour: cacheHourObj.length ? mathNum < 10 ? "0".concat(mathNum) : mathNum : '00',
                    end_hour: currentHour
                  };
                  _context.next = 24;
                  return reqFn(_objectSpread(_objectSpread(_objectSpread({
                    days: 1,
                    time: todayTime,
                    kind: 1
                  }, _this.searchData), _this.defaultData()), hourDate));

                case 24:
                  queryData = _context.sent;
                  queryData.data[todayTime] = _objectSpread(_objectSpread({}, cacheHourData), queryData.data.data[todayTime]); // 默认数据

                  defaultData = {
                    "activate_device": 0,
                    "new_device_recharge_amount": 0,
                    "new_device_recharge_num": 0,
                    "recharge_amount": 0,
                    "register_num": 0,
                    "login_num": 0,
                    "recharge_num": 0,
                    "online_num": 0,
                    "arppu": 0,
                    "register_recharge_pnum": 0,
                    "register_recharge_amount": 0,
                    "recharge_amountexchange": 0,
                    "register_recharge_amountexchange": 0,
                    "new_device_recharge_amountexchange": 0,
                    "date": todayTime
                  };

                  _this.hourList.forEach(function (i) {
                    if (!queryData.data[todayTime][i < 10 ? "0".concat(i) : i]) {
                      queryData.data[todayTime][i < 10 ? "0".concat(i) : i] = _objectSpread({}, defaultData);
                    }
                  });

                  handleQueryData(queryData);
                  _context.next = 35;
                  break;

                case 31:
                  _context.next = 33;
                  return reqFn(_objectSpread(_objectSpread({
                    days: 1,
                    time: todayTime,
                    kind: 1
                  }, _this.searchData), _this.defaultData()));

                case 33:
                  _queryData = _context.sent;
                  handleQueryData(_queryData);

                case 35:
                  _this.reqLoading = false;
                  _this.rawDatas = res.data;
                  delete _this.rawDatas.data;
                  delete _this.rawDatas.summary;

                  _this.IntegralscreenControls('IntegralrawData');

                case 40:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    IntegralscreenControls: function IntegralscreenControls() {
      var _this2 = this;

      var tableData = [];
      var tableList = [];
      var knum = -1;
      var screen = [];
      this.originaltableList.map(function (item) {
        if (_this2.screen.findIndex(function (t) {
          return t == item.key;
        }) > -1) {
          screen.push(item);
        }
      });
      screen.forEach(function (item) {
        tableList.push({
          label: item.name,
          prop: item.key,
          list: []
        });
      });

      var _loop = function _loop(i) {
        // 表格头部数据处理
        var d = {};

        for (var k in _this2.rawDatas[i]) {
          var c = k.substring(0, 1) == "0" ? k.substring(1, 2) : k;
          d[c] = _this2.rawDatas[i][k];
          d[c]['date'] = i;
        }

        tableList.map(function (item) {
          item.list.push({
            label: i,
            prop: item.prop + i
          });
        }); // 表格数据处理

        for (var _k in d) {
          knum += 1;
          var h = parseInt(_k) + 1;
          tableData.push({
            hours: (_k < 10 ? '0' + _k : _k) + '~' + (h < 10 ? '0' + h : h) + '点'
          });
          d[_k]['recharge_amountexchange'] = Number(d[_k]['recharge_amount']) * _this2.exchangeRate;
          d[_k]['register_recharge_amountexchange'] = Number(d[_k]['register_recharge_amount']) * _this2.exchangeRate;
          d[_k]['new_device_recharge_amountexchange'] = Number(d[_k]['new_device_recharge_amount']) * _this2.exchangeRate;

          for (var j in d[_k]) {
            var text = d[_k][j];

            if (j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'arppu' || j == 'new_device_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
              if (j == 'new_device_recharge_amount' || j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
                text = _this2.isyjfmvnd() ? Number(d[_k][j]).toFixed(3) : _this2.$utils.conversion(d[_k][j]).toFixed(3);
              } else {
                text = _this2.$utils.conversion(d[_k][j]).toFixed(2);
              }
            }

            tableData[knum][j + d[_k]['date']] = text;
          }

          if (knum == 23) {
            knum = -1;
          }
        }
      };

      for (var i in this.rawDatas) {
        _loop(i);
      }

      tableData.splice(24, tableData.length - 24);
      tableList.unshift({
        label: '',
        list: [{
          label: '时间',
          prop: 'hours',
          width: 100
        }]
      });
      this.tableData = tableData;
      this.tableList = tableList;
    }
  }
};